{
  "el": {
    "marketplace_partner": {
      "contact_me": {
        "success": "Θα επικοινωνήσουμε μαζί σου σύντομα.",
        "failure": "Παρουσιάστηκε ένα απρόσμενο σφάλμα.",
        "button": "Επικοινωνία μαζί μου"
      }
    }
  }
}
